export default __webpack_public_path__ + "1649285600674f6f8e02dbff00d0d21b.svg";